import { Breadcrumb, Card, Empty, Form, Select } from "antd";
import { useSelector } from "react-redux";
import { accountListSelector } from "../../store/selectors/app.selector";
import { useCallback, useEffect } from "react";
import ChequeService from "../../services/cheque.service";
import moment from "moment/moment";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../assests/images/bulkpaybreadupload.svg";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function Cheques() {
  const accountList = useSelector(accountListSelector);
  const [dataSource, setDataSource] = useState([]);
  const [accountNo, setAccountNo] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation();

  useEffect(() => {
    if (accountList.length > 0) {
      if (location.state) {
        chequeDetails(location.state?.accountNo);
        setAccountNo(location.state?.accountNo);
      } else {
        chequeDetails(accountList[0]?.accountNo);
        setAccountNo(accountList[0]?.accountNo);
      }
    }
  }, [accountList]);

  const handleAccountNo = (value) => {
    setAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    chequeDetails(accountDet?.accountNo);
  };

  const chequeDetails = useCallback(async (accountNo) => {
    try {
      const response = await ChequeService.chequeDetails({
        accountNo: accountNo,
      });
      if (response.status === 200) {
        setDataSource(response.data["data"] || []);
      }
    } catch (error) {}
  }, []);

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>My Cheques</span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">My Cheques</h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            <label style={{ fontSize: "18px", padding: "5px" }}>
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={accountNo}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      <Card
        className="application-card"
        style={{ minHeight: 300, padding: "10px 20px", marginBottom: 20 }}
      >
        <p>Please select a cheque book to view the details of the cheques</p>

        {dataSource.length === 0 ? (
          <Empty description="No cheques available" />
        ) : (
          <div className="ft-table">
            <table className="table">
              <thead style={{ backgroundColor: "#F1F1F1" }}>
                <tr>
                  <th>
                    {t("pages.settings.cheque_book", {
                      defaultValue: "Cheque Book",
                    })}
                  </th>
                  <th>Issued On</th>
                  <th>
                    {t("pages.settings.no_of_leaves", {
                      defaultValue: "Number Of Leaves",
                    })}
                  </th>
                  <th>Issued Leaves</th>
                </tr>
              </thead>
              <tbody>
                {dataSource.map((option, idx) => (
                  <tr key={idx}>
                    <td
                      className="pay-now-text"
                      onClick={() =>
                        navigate("/cheques/status", {
                          state: { ...option, accountNo: accountNo },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {option.beginCheque}
                    </td>
                    <td> {moment(option?.IssueDate).format("DD-MM-YYYY")}</td>
                    <td>{option?.noOfLeaves}</td>
                    <td>{option?.issuedLeaves}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
